<admin-app-header></admin-app-header>
<app-prospecting-nav></app-prospecting-nav>

<div class="map-page">
    <div class="controls-bar">
        <div class="controls-left">
            <h1><i class="fa-solid fa-map-location-dot"></i> Prospecting Map</h1>
            <span class="count-badge">{{ displayProspects.length | number }} prospects &middot; {{ displayPublishedParkings.length + displayUnpublishedParkings.length | number }} parkings</span>
        </div>
        <div class="filter-panels">
            <!-- Parkings filter -->
            <div class="filter-dropdown">
                <button class="filter-trigger" (click)="parkingsDropdownOpen = !parkingsDropdownOpen; prospectsDropdownOpen = false">
                    <i class="fa-solid fa-square-parking"></i> Parkings
                    <i class="fa-solid fa-chevron-down fa-xs"></i>
                </button>
                <div class="filter-panel" *ngIf="parkingsDropdownOpen">
                    <label class="filter-option" (click)="togglePublishedParkings()">
                        <span class="filter-check" [class.checked]="showPublishedParkings"><i class="fa-solid fa-check" *ngIf="showPublishedParkings"></i></span>
                        <span class="filter-dot pin-shape" style="background-color: #22c55e"></span>
                        <span class="filter-label">Published</span>
                        <span class="filter-count">{{ publishedParkings.length }}</span>
                    </label>
                    <label class="filter-option" (click)="toggleUnpublishedParkings()">
                        <span class="filter-check" [class.checked]="showUnpublishedParkings"><i class="fa-solid fa-check" *ngIf="showUnpublishedParkings"></i></span>
                        <span class="filter-dot pin-shape" style="background-color: #f59e0b"></span>
                        <span class="filter-label">Unpublished</span>
                        <span class="filter-count">{{ unpublishedParkings.length }}</span>
                    </label>
                </div>
            </div>

            <!-- Prospects filter -->
            <div class="filter-dropdown">
                <button class="filter-trigger" (click)="prospectsDropdownOpen = !prospectsDropdownOpen; parkingsDropdownOpen = false">
                    <i class="fa-solid fa-building"></i> Prospects
                    <i class="fa-solid fa-chevron-down fa-xs"></i>
                </button>
                <div class="filter-panel" *ngIf="prospectsDropdownOpen">
                    <label class="filter-option" *ngFor="let key of statusKeys" (click)="toggleStatus(key)">
                        <span class="filter-check" [class.checked]="statusConfig[key].visible"><i class="fa-solid fa-check" *ngIf="statusConfig[key].visible"></i></span>
                        <span class="filter-dot" [style.background-color]="statusConfig[key].color"></span>
                        <span class="filter-label">{{ statusConfig[key].label }}</span>
                        <span class="filter-count">{{ statusConfig[key].count }}</span>
                    </label>
                    <label class="filter-option" (click)="toggleClosedLeads()">
                        <span class="filter-check" [class.checked]="showClosedLeads"><i class="fa-solid fa-check" *ngIf="showClosedLeads"></i></span>
                        <span class="filter-dot" style="background-color: #8b0000"></span>
                        <span class="filter-label">Closed Leads</span>
                        <span class="filter-count" *ngIf="closedLeadsLoaded">{{ closedLeads.length }}</span>
                    </label>
                </div>
            </div>

            <!-- Existing assignee/source filters -->
            <select [(ngModel)]="assigneeFilter" (ngModelChange)="applyFilters()">
                <option value="">All assignees</option>
                <option *ngFor="let a of assignees" [value]="a.$key">{{ a.displayName }}</option>
            </select>
            <select [(ngModel)]="sourceFilter" (ngModelChange)="applyFilters()">
                <option value="">All sources</option>
                <option *ngFor="let s of sourceOptions" [value]="s">{{ sourceLabels[s] }}</option>
            </select>
            <select [(ngModel)]="searchTermFilter" (ngModelChange)="applyFilters()">
                <option value="">All search terms</option>
                <option *ngFor="let t of searchTermOptions" [value]="t">{{ t }}</option>
            </select>
            <select [(ngModel)]="prospectTypeFilter" (ngModelChange)="applyFilters()">
                <option value="">All types</option>
                <option *ngFor="let t of prospectTypeOptions" [value]="t">{{ prospectTypeLabels[t] }}</option>
            </select>
        </div>
    </div>

    <div class="loading-state" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Loading prospects...</p>
    </div>

    <div class="map-shell" *ngIf="!loading">
        <agm-map
            [latitude]="initialLat"
            [longitude]="initialLng"
            [zoom]="initialZoom"
            [scrollwheel]="true"
            [streetViewControl]="false"
            [mapTypeControl]="true"
            [styles]="mapStyles"
            (centerChange)="onCenterChange($event)"
            (zoomChange)="onZoomChange($event)"
            (boundsChange)="onBoundsChange($event)"
            style="height: 100%"
        >
            <agm-marker
                *ngFor="let p of displayProspects"
                [latitude]="p.latitude!"
                [longitude]="p.longitude!"
                [iconUrl]="iconUrlMap[p.$key!]"
                (markerClick)="onProspectClick(p)"
            ></agm-marker>

            <ng-container *ngIf="showPublishedParkings">
                <agm-marker
                    *ngFor="let parking of displayPublishedParkings"
                    [latitude]="parking.parkingLocation.latitude"
                    [longitude]="parking.parkingLocation.longitude"
                    [iconUrl]="publishedParkingIconUrl"
                    (markerClick)="onParkingClick(parking)"
                ></agm-marker>
            </ng-container>
            <ng-container *ngIf="showUnpublishedParkings">
                <agm-marker
                    *ngFor="let parking of displayUnpublishedParkings"
                    [latitude]="parking.parkingLocation.latitude"
                    [longitude]="parking.parkingLocation.longitude"
                    [iconUrl]="unpublishedParkingIconUrl"
                    (markerClick)="onParkingClick(parking)"
                ></agm-marker>
            </ng-container>

            <agm-info-window
                *ngIf="selectedParking"
                [latitude]="selectedParking.parkingLocation.latitude"
                [longitude]="selectedParking.parkingLocation.longitude"
                [isOpen]="!!selectedParking"
                (infoWindowClose)="onParkingInfoClose()"
            >
                <div class="parking-info">
                    <h3>{{ selectedParking.title || 'Untitled Parking' }}</h3>
                    <p class="parking-info__address" *ngIf="parkingAddress(selectedParking)">
                        <i class="fa-solid fa-location-dot"></i> {{ parkingAddress(selectedParking) }}
                    </p>
                    <a [href]="'/parking/' + selectedParking.$key" target="_blank" class="parking-info__link">
                        <i class="fa-solid fa-arrow-up-right-from-square"></i> View parking page
                    </a>
                </div>
            </agm-info-window>

            <ng-container *ngIf="showClosedLeads">
                <agm-marker
                    *ngFor="let lead of displayClosedLeads"
                    [latitude]="lead.latitude!"
                    [longitude]="lead.longitude!"
                    [iconUrl]="closedLeadIconUrl"
                    (markerClick)="onClosedLeadClick(lead)"
                ></agm-marker>
            </ng-container>

            <agm-info-window
                *ngIf="selectedClosedLead"
                [latitude]="selectedClosedLead.latitude!"
                [longitude]="selectedClosedLead.longitude!"
                [isOpen]="!!selectedClosedLead"
                (infoWindowClose)="onClosedLeadInfoClose()"
            >
                <div class="closed-lead-info">
                    <h3>{{ selectedClosedLead.companyName || selectedClosedLead.firstName + ' ' + selectedClosedLead.lastName }}</h3>
                    <p *ngIf="selectedClosedLead.fullAddress" class="closed-lead-info__row">
                        <i class="fa-solid fa-location-dot"></i> {{ selectedClosedLead.fullAddress }}
                    </p>
                    <p *ngIf="selectedClosedLead.numberOfBays" class="closed-lead-info__row">
                        <i class="fa-solid fa-car"></i> {{ selectedClosedLead.numberOfBays }} bay{{ selectedClosedLead.numberOfBays !== 1 ? 's' : '' }} required
                    </p>
                    <p *ngIf="selectedClosedLead.monthsRequired" class="closed-lead-info__row">
                        <i class="fa-solid fa-calendar"></i> {{ selectedClosedLead.monthsRequired }} month{{ selectedClosedLead.monthsRequired !== 1 ? 's' : '' }}
                    </p>
                    <p *ngIf="selectedClosedLead.broadLocation" class="closed-lead-info__row">
                        <i class="fa-solid fa-map"></i> {{ selectedClosedLead.broadLocation }}
                    </p>
                    <p *ngIf="selectedClosedLead.email" class="closed-lead-info__row">
                        <i class="fa-solid fa-envelope"></i> {{ selectedClosedLead.email }}
                    </p>
                    <p *ngIf="selectedClosedLead.phoneNumber" class="closed-lead-info__row">
                        <i class="fa-solid fa-phone"></i> {{ selectedClosedLead.phoneNumber }}
                    </p>
                    <p class="closed-lead-info__reason">
                        <i class="fa-solid fa-circle-xmark"></i> {{ selectedClosedLead.leadClosedReason }}
                    </p>
                    <div *ngIf="selectedClosedLeadNearestParkings?.length" class="closed-lead-info__nearest">
                        <h4>Nearest parkings</h4>
                        <div class="closed-lead-info__parking" *ngFor="let n of selectedClosedLeadNearestParkings">
                            <i class="fa-solid fa-square-parking"></i>
                            <span>{{ n.parkingName }}</span>
                            <strong>{{ n.distanceKm }} km</strong>
                        </div>
                    </div>
                </div>
            </agm-info-window>
        </agm-map>
    </div>
</div>
